import axios from '../utils/request.js'

export default {
 
  login(data) { 
    data = JSON.stringify(data)
    return axios.postjson('/pay/H5PhoneGetLogin',data)
  },
  getcode(data) {
    data = JSON.stringify(data)
    return axios.postjson('/app/SendSmsCode', data)
  },
};